import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { TranslateModuleLoad } from '@app/translate-import';
import { LanguageTabComponent } from './language';
import {
	PointOfInterestService,
	PointOfInterestFormComponent,
	PointOfInterestFiltersComponent,
	PointOfInterestTableComponent,
	PointOfInterestSelectComponent,
	PointOfInterestListTopBarComponent,
	PointOfInterestCountComponent,
} from './point-of-interest';
import {
	UserService,
	UserFormComponent,
	UserFiltersComponent,
	UserTableComponent,
	UserSelectComponent,
	UserListTopBarComponent,
	UserCountComponent,
} from './user';
import {
	VideoService,
	VideoFormComponent,
	VideoFiltersComponent,
	VideoTableComponent,
	VideoSelectComponent,
	VideoListTopBarComponent,
	VideoCountComponent,
} from './video';
import {
	AudioService,
	AudioFormComponent,
	AudioFiltersComponent,
	AudioTableComponent,
	AudioSelectComponent,
	AudioListTopBarComponent,
	AudioCountComponent,
} from './audio';
import {
	TextTranslatedService,
	TextTranslatedFormComponent,
	TextTranslatedFiltersComponent,
	TextTranslatedTableComponent,
	TextTranslatedSelectComponent,
	TextTranslatedListTopBarComponent,
	TextTranslatedCountComponent,
} from './text-translated';
import {
	ImageService,
	ImageFormComponent,
	ImageFiltersComponent,
	ImageTableComponent,
	ImageSelectComponent,
	ImageListTopBarComponent,
	ImageCountComponent,
	ImageMultipleFormComponent,
	ImageModalButtonComponent,
} from './image';
import {
	LanguageService,
	LanguageFormComponent,
	LanguageFiltersComponent,
	LanguageTableComponent,
	LanguageSelectComponent,
	LanguageListTopBarComponent,
	LanguageCountComponent,
} from './language';
import {
	CategoryService,
	CategoryFormComponent,
	CategoryFiltersComponent,
	CategoryTableComponent,
	CategorySelectComponent,
	CategoryListTopBarComponent,
	CategoryCountComponent,
} from './category';
import {
	RouteService,
	RouteFormComponent,
	RouteFiltersComponent,
	RouteTableComponent,
	RouteSelectComponent,
	RouteListTopBarComponent,
	RouteCountComponent,
} from './route';
import {
	PlateauService,
	PlateauFormComponent,
	PlateauFiltersComponent,
	PlateauTableComponent,
	PlateauSelectComponent,
	PlateauListTopBarComponent,
	PlateauCountComponent,
	PlateauBuildActionComponent,
} from './plateau';
import {
	AudioDescriptionService,
	AudioDescriptionFormComponent,
	AudioDescriptionFiltersComponent,
	AudioDescriptionTableComponent,
	AudioDescriptionSelectComponent,
	AudioDescriptionListTopBarComponent,
	AudioDescriptionCountComponent,
} from './audio-description';
import {
	DiaporamaService,
	DiaporamaFormComponent,
	DiaporamaFiltersComponent,
	DiaporamaTableComponent,
	DiaporamaSelectComponent,
	DiaporamaListTopBarComponent,
	DiaporamaCountComponent,
	DiaporamaSliderComponent,
} from './diaporama';
import {
	AboutService,
	AboutFormComponent,
	AboutFiltersComponent,
	AboutTableComponent,
	AboutSelectComponent,
	AboutListTopBarComponent,
	AboutCountComponent,
} from './about';
import {
	CreditService,
	CreditFormComponent,
	CreditFiltersComponent,
	CreditTableComponent,
	CreditSelectComponent,
	CreditListTopBarComponent,
	CreditCountComponent,
} from './credit';
import {
	MarkerService,
	MarkerFormComponent,
	MarkerFiltersComponent,
	MarkerTableComponent,
	MarkerSelectComponent,
	MarkerListTopBarComponent,
	MarkerCountComponent,
	MarkerBulkFormComponent,
} from './marker';
import { ImageModalComponent } from './image/image-modal/image-modal.component';
import {
	ModuleQCMCountComponent,
	ModuleQCMFiltersComponent,
	ModuleQCMFormComponent,
	ModuleQCMListTopBarComponent,
	ModuleQCMSelectComponent,
	ModuleQCMService,
	ModuleQCMTableComponent,
} from './module-qcm';
import {
	ModuleQCMResponseCountComponent,
	ModuleQCMResponseFiltersComponent,
	ModuleQCMResponseFormComponent,
	ModuleQCMResponseInlineFormComponent,
	ModuleQCMResponseListTopBarComponent,
	ModuleQCMResponseSelectComponent,
	ModuleQCMResponseService,
	ModuleQCMResponseTableComponent,
} from './module-qcm-response';
import {
	ModuleEnSavoirPlusCountComponent,
	ModuleEnSavoirPlusFiltersComponent,
	ModuleEnSavoirPlusFormComponent,
	ModuleEnSavoirPlusListTopBarComponent,
	ModuleEnSavoirPlusSelectComponent,
	ModuleEnSavoirPlusService,
	ModuleEnSavoirPlusTableComponent,
} from './module-en-savoir-plus';
import { BuildInfosService } from '@app/services';
@NgModule({
	imports: [CommonModule, SharedModule, TranslateModuleLoad()],
	declarations: [
		PointOfInterestFormComponent,
		PointOfInterestFiltersComponent,
		PointOfInterestTableComponent,
		PointOfInterestSelectComponent,
		PointOfInterestListTopBarComponent,
		PointOfInterestCountComponent,
		UserFormComponent,
		UserFiltersComponent,
		UserTableComponent,
		UserSelectComponent,
		UserListTopBarComponent,
		UserCountComponent,
		VideoFormComponent,
		VideoFiltersComponent,
		VideoTableComponent,
		VideoSelectComponent,
		VideoListTopBarComponent,
		VideoCountComponent,
		AudioFormComponent,
		AudioFiltersComponent,
		AudioTableComponent,
		AudioSelectComponent,
		AudioListTopBarComponent,
		AudioCountComponent,
		TextTranslatedFormComponent,
		TextTranslatedFiltersComponent,
		TextTranslatedTableComponent,
		TextTranslatedSelectComponent,
		TextTranslatedListTopBarComponent,
		TextTranslatedCountComponent,
		ImageFormComponent,
		ImageFiltersComponent,
		ImageTableComponent,
		ImageSelectComponent,
		ImageListTopBarComponent,
		ImageCountComponent,
		ImageMultipleFormComponent,
		LanguageFormComponent,
		LanguageFiltersComponent,
		LanguageTableComponent,
		LanguageSelectComponent,
		LanguageListTopBarComponent,
		LanguageCountComponent,
		CategoryFormComponent,
		CategoryFiltersComponent,
		CategoryTableComponent,
		CategorySelectComponent,
		CategoryListTopBarComponent,
		CategoryCountComponent,
		RouteFormComponent,
		RouteFiltersComponent,
		RouteTableComponent,
		RouteSelectComponent,
		RouteListTopBarComponent,
		RouteCountComponent,
		PlateauFormComponent,
		PlateauFiltersComponent,
		PlateauTableComponent,
		PlateauSelectComponent,
		PlateauBuildActionComponent,
		PlateauListTopBarComponent,
		PlateauCountComponent,
		AudioDescriptionFormComponent,
		AudioDescriptionFiltersComponent,
		AudioDescriptionTableComponent,
		AudioDescriptionSelectComponent,
		AudioDescriptionListTopBarComponent,
		AudioDescriptionCountComponent,
		DiaporamaFormComponent,
		DiaporamaFiltersComponent,
		DiaporamaTableComponent,
		DiaporamaSelectComponent,
		DiaporamaListTopBarComponent,
		DiaporamaCountComponent,
		AboutFormComponent,
		AboutFiltersComponent,
		AboutTableComponent,
		AboutSelectComponent,
		AboutListTopBarComponent,
		AboutCountComponent,
		CreditFormComponent,
		CreditFiltersComponent,
		CreditTableComponent,
		CreditSelectComponent,
		CreditListTopBarComponent,
		CreditCountComponent,
		MarkerFormComponent,
		MarkerFiltersComponent,
		MarkerTableComponent,
		MarkerSelectComponent,
		MarkerListTopBarComponent,
		MarkerBulkFormComponent,
		MarkerCountComponent,
		LanguageTabComponent,
		ImageModalButtonComponent,
		DiaporamaSliderComponent,
		ModuleQCMFormComponent,
		ModuleQCMFiltersComponent,
		ModuleQCMTableComponent,
		ModuleQCMSelectComponent,
		ModuleQCMListTopBarComponent,
		ModuleQCMCountComponent,
		ModuleQCMResponseFormComponent,
		ModuleQCMResponseInlineFormComponent,
		ModuleQCMResponseFiltersComponent,
		ModuleQCMResponseTableComponent,
		ModuleQCMResponseSelectComponent,
		ModuleQCMResponseListTopBarComponent,
		ModuleQCMResponseCountComponent,
		ModuleEnSavoirPlusFormComponent,
		ModuleEnSavoirPlusFiltersComponent,
		ModuleEnSavoirPlusTableComponent,
		ModuleEnSavoirPlusSelectComponent,
		ModuleEnSavoirPlusListTopBarComponent,
		ModuleEnSavoirPlusCountComponent,
	],
	providers: [
		PointOfInterestService,
		UserService,
		VideoService,
		AudioService,
		TextTranslatedService,
		ImageService,
		LanguageService,
		CategoryService,
		RouteService,
		PlateauService,
		AudioDescriptionService,
		DiaporamaService,
		AboutService,
		CreditService,
		MarkerService,
		ModuleQCMService,
		ModuleQCMResponseService,
		ModuleEnSavoirPlusService,
		BuildInfosService,
	],
	exports: [
		PointOfInterestFormComponent,
		PointOfInterestFiltersComponent,
		PointOfInterestTableComponent,
		PointOfInterestSelectComponent,
		PointOfInterestListTopBarComponent,
		PointOfInterestCountComponent,
		UserFormComponent,
		UserFiltersComponent,
		UserTableComponent,
		UserSelectComponent,
		UserListTopBarComponent,
		UserCountComponent,
		VideoFormComponent,
		VideoFiltersComponent,
		VideoTableComponent,
		VideoSelectComponent,
		VideoListTopBarComponent,
		VideoCountComponent,
		AudioFormComponent,
		AudioFiltersComponent,
		AudioTableComponent,
		AudioSelectComponent,
		AudioListTopBarComponent,
		AudioCountComponent,
		TextTranslatedFormComponent,
		TextTranslatedFiltersComponent,
		TextTranslatedTableComponent,
		TextTranslatedSelectComponent,
		TextTranslatedListTopBarComponent,
		TextTranslatedCountComponent,
		ImageFormComponent,
		ImageFiltersComponent,
		ImageTableComponent,
		ImageSelectComponent,
		ImageListTopBarComponent,
		ImageCountComponent,
		ImageMultipleFormComponent,
		LanguageFormComponent,
		LanguageFiltersComponent,
		LanguageTableComponent,
		LanguageSelectComponent,
		LanguageListTopBarComponent,
		LanguageCountComponent,
		CategoryFormComponent,
		CategoryFiltersComponent,
		CategoryTableComponent,
		CategorySelectComponent,
		CategoryListTopBarComponent,
		CategoryCountComponent,
		RouteFormComponent,
		RouteFiltersComponent,
		RouteTableComponent,
		RouteSelectComponent,
		RouteListTopBarComponent,
		RouteCountComponent,
		PlateauFormComponent,
		PlateauFiltersComponent,
		PlateauTableComponent,
		PlateauSelectComponent,
		PlateauListTopBarComponent,
		PlateauCountComponent,
		PlateauBuildActionComponent,
		AudioDescriptionFormComponent,
		AudioDescriptionFiltersComponent,
		AudioDescriptionTableComponent,
		AudioDescriptionSelectComponent,
		AudioDescriptionListTopBarComponent,
		AudioDescriptionCountComponent,
		DiaporamaFormComponent,
		DiaporamaFiltersComponent,
		DiaporamaTableComponent,
		DiaporamaSelectComponent,
		DiaporamaListTopBarComponent,
		DiaporamaCountComponent,
		AboutFormComponent,
		AboutFiltersComponent,
		AboutTableComponent,
		AboutSelectComponent,
		AboutListTopBarComponent,
		AboutCountComponent,
		CreditFormComponent,
		CreditFiltersComponent,
		CreditTableComponent,
		CreditSelectComponent,
		CreditListTopBarComponent,
		CreditCountComponent,
		MarkerFormComponent,
		MarkerFiltersComponent,
		MarkerTableComponent,
		MarkerSelectComponent,
		MarkerBulkFormComponent,
		MarkerListTopBarComponent,
		MarkerCountComponent,
		LanguageTabComponent,
		ImageModalButtonComponent,
		ModuleQCMFormComponent,
		ModuleQCMFiltersComponent,
		ModuleQCMTableComponent,
		ModuleQCMSelectComponent,
		ModuleQCMListTopBarComponent,
		ModuleQCMCountComponent,
		ModuleQCMResponseFormComponent,
		ModuleQCMResponseInlineFormComponent,
		ModuleQCMResponseFiltersComponent,
		ModuleQCMResponseTableComponent,
		ModuleQCMResponseSelectComponent,
		ModuleQCMResponseListTopBarComponent,
		ModuleQCMResponseCountComponent,
		ModuleEnSavoirPlusFormComponent,
		ModuleEnSavoirPlusFiltersComponent,
		ModuleEnSavoirPlusTableComponent,
		ModuleEnSavoirPlusSelectComponent,
		ModuleEnSavoirPlusListTopBarComponent,
		ModuleEnSavoirPlusCountComponent,
	],
})
export class ModelsModule {}
